<template>
  <NewBsBox
    :bs="{ 'cmp.multicascade': 'wrapper' }"
    class="cas-level"
  >
    <NewBsBox :bs="{ 'cmp.multicascade': 'header' }">
      {{ numberCn }}级{{ optionName }}
    </NewBsBox>

    <NewBsBox
      v-if="filterAble"
      :bs="{ py: 6, px: 12 }"
    >
      <BeerInput
        v-model="keyword"
        :clearable="true"
        :bs="{ width: '100%' }"
      >
        <template #left>
          <BeerIcon
            :bs="{
              ml: 11, fill: 'mute'
            }"
            icon="search"
          />
        </template>
      </BeerInput>
    </NewBsBox>
    <NewBsBox :bs="{ 'cmp.multicascade': 'levelbox' }">
      <template
        v-if="prevContext"
      >
        <NewBsBox
          v-if="!prevContext.loaded"
          :bs="{ 'cmp.multicascade': 'empty'}"
        >
          <BeerLoading />
        </NewBsBox>
        <NewBsBox
          v-else-if="prevContext.error"
          :bs="{ 'cmp.multicascade': 'empty'}"
        >
          {{ prevContext.error }}
        </NewBsBox>

        <NewBsBox
          v-else-if="prevContext.children.length < 1"
          :bs="{ 'cmp.multicascade': 'empty'}"
        >
          无内容
        </NewBsBox>

        <template v-else>
          <slot :keyword="keyword" />
        </template>
      </template>

      <NewBsBox
        v-else
        :bs="{ 'cmp.multicascade': 'empty', fontSize: '14px'}"
      >
        请选择上一级选项
      </NewBsBox>
    </NewBsBox>
  </NewBsBox>
</template>

<script>
  import NewBsBox from '@xhs/yam-beer/cmp/primitive/NewBsBox'
  import BeerLoading from '@xhs/yam-beer/cmp/common/Spinner/Loading.vue'
  import BeerIcon from '@xhs/yam-beer/cmp/common/Icon/Icon.vue'
  import BeerInput from '@xhs/yam-beer/cmp/dataEntry/Input/Input.vue'
  import initStyle from './MultiCascadeSelect/style'

  initStyle()

  const transLevelDict = {
    1: '一',
    2: '二',
    3: '三',
    4: '四',
    5: '五',
    6: '六',
    7: '七',
    8: '八',
    9: '九',
    10: '十',
  }

  export default {
    name: 'CascadeLevel',
    components: {
      BeerIcon,
      BeerInput,
      NewBsBox,
      BeerLoading,
    },
    props: {
      /**
       * 选项列表所属的 level
       */
      level: {
        type: Number,
        default: 0,
      },
      prevContext: {
        type: Object,
      },
      filterAble: {
        type: Boolean,
        default: false,
      },
      /**
       * 选项名称，显示在标题或提示
       */
      optionName: {
        type: String,
        default: '选项',
      },
    },
    data() {
      return {
        keyword: null,
      }
    },
    computed: {
      numberCn() {
        return transLevelDict[this.level]
      },
    },
  }
</script>
